import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingInfoActions from '../actions/hosting-info.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {delayWhen, filter, map, mergeMap, switchMap, withLatestFrom} from 'rxjs/operators';
import {LoadInfo} from '../actions';
import {HostingService} from "../../websites/website/hosting/hosting.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../index";
import {UserSubscription} from "../../user/user-subscription";
import {User} from "../../user/user";
import {combineLatest, ReplaySubject} from "rxjs";
import {Utils} from "../../shared/utils/utils";

@Injectable()
export class HostingInfoEffects {

  private userData$ = new ReplaySubject<[User, UserSubscription]>();
  loadInfo$ = createEffect(() => this._actions$.pipe(
    ofType(hostingInfoActions.LOAD_INFO),
    delayWhen(() => this.userData$.asObservable()),
    withLatestFrom(this.userData$.asObservable()),
    mergeMap(([action, [user, userSubscription]]: [LoadInfo, [User, UserSubscription]]) => {
      const demoUser = Utils.isDemoUser(userSubscription, user);
      return this._hostingService.getHostingInfoData(action.payload, demoUser)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingInfoActions.LoadInfoSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new hostingInfoActions.LoadInfoFail(response.message);
          })
        );
    })
  ));

  /*@Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
    .pipe(
      filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
      map((action: UpdateWebsiteSubData) => {
        return new hostingLogsActions.LoadLogs(action.payload.id, 1000, "access");
      })
    );*/

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService,
    private _store: Store<fromStore.DbStoreState>,
  ) {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
        )),
      ).subscribe(userData => this.userData$.next(userData));
  }


}
